// assets
import { TransactionOutlined, WalletOutlined, BankOutlined } from '@ant-design/icons';

// icons
const icons = {
  TransactionOutlined,
  WalletOutlined,
  BankOutlined
};

// ==============================|| MENU ITEMS - FINANCE ||============================== //

const finance = {
  id: 'group-finance',
  title: 'Finance',
  type: 'group',
  children: [
    {
      id: 'transactions',
      title: 'Transactions',
      type: 'item',
      url: '/finance/transactions',
      icon: icons.TransactionOutlined
    },
    {
      id: 'deposit',
      title: 'Deposit',
      type: 'item',
      url: '/finance/deposit',
      icon: icons.WalletOutlined
    },
    {
      id: 'withdraw',
      title: 'Withdraw',
      type: 'item',
      url: '/finance/withdraw',
      icon: icons.BankOutlined
    }
  ]
};

export default finance;
